import React, { useEffect, useState } from "react";
import {
  Table,
  Tag,
  Button,
  Space,
  Card,
  Typography,
  message,
  Popconfirm,
} from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import adminService from "../../services/userApprovalService";
import toast from "react-hot-toast";
import DeleteUserModal from "../../components/UserApproval/DeleteUserModal";
import { getAllReports } from "../../services/reports";
import dayjs from "dayjs";
const { Title, Text } = Typography;

const AdminReports = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(false);
  const [update, setUpdate] = useState(false);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await getAllReports();
      console.log(res);
      setReports(res.data);
    } catch {
      message.error("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();

    if (update) {
      setUpdate(false);
    }
  }, [update]);

  const columns = [
    {
      title: "Full Name",
      key: "fullName",
      render: (_, record) => <Text strong>{record.user?.fullName || "—"}</Text>,
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      render: (text) => dayjs(text).format("DD MMM YYYY, hh:mm A"),
      width: "30%",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
  ];

  return (
    <>
      <div style={{ padding: 24 }}>
        <Card
          title={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <Title level={3} style={{ marginBottom: 0 }}>
                  User Approvals
                </Title>
                <Text type="secondary">
                  Manage user registrations and approvals
                </Text>
              </div>
            </div>
          }
          bordered={false}
          style={{
            borderRadius: 10,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          <Table
            columns={columns}
            dataSource={reports}
            rowKey="_id"
            loading={loading}
            pagination={{ pageSize: 8 }}
          />
        </Card>
      </div>
    </>
  );
};

export default AdminReports;
